export const agentPlayground = {
  header: {
    title: "اختبار وكيل الذكاء الاصطناعي",
    chip: "استقبال بالذكاء الاصطناعي · بيتا",
    sub: "تحدّث مع الوكيل المتقدّم دون إرسال أي شيء عبر واتساب.",
  },
  context: {
    title: "السياق",
    listingLabel: "الإعلان",
    listingPlaceholder: "اختر إعلانًا…",
    allListings: "🌐 جميع أماكن الإقامة (الحجوزات الجديدة)",
    accountModeHint:
      "يرد الوكيل كما لو لم يكن مرتبطًا بمكان إقامة محدد: مثالي لاختبار طلبات الحجز.",
    guestStatusLabel: "حالة الضيف",
    stay: {
      auto: "تلقائي",
      inStay: "مقيم الآن (أثناء الإقامة)",
      beforeArrival: "لم يصل بعد (حجز مستقبلي)",
      after: "انتهت الإقامة",
    },
    guestStatusHint: "حاكِ لحظة الضيف لرؤية الردود المختلفة.",
    reservationIdLabel: "رقم الحجز",
    optional: "(اختياري)",
    reservationIdPlaceholder: "مثال: 1234",
    phoneLabel: "هاتف الضيف",
    phonePlaceholder: "+34...",
    langLabel: "اللغة",
    lang: {
      auto: "تلقائي",
      es: "الإسبانية",
      en: "الإنجليزية",
      pt: "البرتغالية",
      fr: "الفرنسية",
      de: "الألمانية",
      pl: "البولندية",
    },
    reset: "إعادة تعيين المحادثة",
  },
  debug: {
    resolvedTitle: "السياق المُحلَّل",
    listing: "الإعلان",
    property: "العقار",
    reservation: "الحجز",
    checkin: "الوصول",
    checkout: "المغادرة",
    lang: "اللغة",
    toolsTitle: "الأدوات المستخدمة",
  },
  chat: {
    emptyPrompt: "اكتب رسالة كما لو كنت الضيف.",
    pay: "ادفع",
    book: "احجز",
    sentAsButton: "في واتساب تُرسَل كزر",
    sentAsList: "في واتساب تُرسَل كقائمة · {button}",
    inputPlaceholder: "اكتب رسالة…",
  },
  suggestions: {
    s1: "متى موعد تسجيل الوصول؟",
    s2: "هل يوجد موقف سيارات؟",
    s3: "هل لديكم واي فاي؟ ما كلمة المرور؟",
    s4: "هل يمكنني تسجيل الوصول مبكرًا؟",
  },
  errors: {
    loadListings: "تعذّر تحميل الإعلانات.",
    chatError: "حدث خطأ أثناء التحدث مع الوكيل.",
    chatReplyFallback: "⚠️ لم أتمكن من الرد. تحقق من السياق أو حاول مرة أخرى.",
  },
  methods: {
    listingFallback: "إعلان رقم {id}",
  },
};
